const initState = {
  user: {},
};

const userReducer = (state = initState, action) => {
  switch (action.type) {
    case "CREATE_USER_ACCOUNT":
      return {
        ...state,
        user: action.data,
      };
    case "GET_CURRENT_USER":
      return {
        ...state,
        user: action.data,
      };
    default:
      break;
  }
  return state;
};

export default userReducer;
